






























































































import { defineComponent, type PropType } from "vue-demi";
import type { PageData } from "@constructor/shared-entity/type";
import getValueForProp from "../../../helper/getValueForProp";
import GGTimerBlock from "../GGTimerBlock.vue";
import GGProductFlashGrid from "../GGProductFlashGrid.vue";
import ViewportToogle from "../../ViewportToogle.vue";
import GGPrice from "../GGPrice.vue";
import GGRowSlider from "../../grid-generation/GGRowSlider/GGRowSlider.vue";

export default defineComponent({
  name: "GGFlash",
  components: {
    GGTimerBlock,
    GGProductFlashGrid,
    ViewportToogle,
    GGRowSlider,
    GGPrice,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  computed: {
    timerSize() {
      return getValueForProp("timerSize", this.data.template.prop) || undefined;
    },
    timerColor() {
      return (
        getValueForProp("timerColor", this.data.template.prop) || undefined
      );
    },
    timerDate() {
      return getValueForProp("timerDate", this.data.template.prop) || undefined;
    },
    backgroundColor() {
      return (
        getValueForProp("bannerBackgroundColor", this.data.template.prop) ||
        "#F8F8F8"
      );
    },
    backgroundDesktop() {
      return (
        getValueForProp("bannerImageDesktop", this.data.template.prop) ||
        undefined
      );
    },
    backgroundMobile() {
      return getValueForProp("bannerImageMobile", this.data.template.prop);
    },
    link() {
      return (
        getValueForProp("buttonLink", this.data.template.prop) || undefined
      );
    },
    linkText() {
      return (
        getValueForProp("buttonLinkText", this.data.template.prop) || undefined
      );
    },
    title() {
      return (
        getValueForProp("sectionTitle", this.data.template.prop) || undefined
      );
    },
    subtitle() {
      return (
        getValueForProp("sectionSubtitle", this.data.template.prop) || undefined
      );
    },
  },
});
